/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback requestCallback
 * @param { boolean } isSuccess
 * @param { string } data
 */

/**
 * Popup de confirmation pour envoyer la facture par courriel.
 * @param {number} invoice_id ID de la facture
 * @param {string} email Adresse courriel par défaut.
 */
let actionSendInvoiceToCustomer = window.actionSendInvoiceToCustomer = function(invoice_id, email, isSoumission){
	isSoumission = isSoumission === true;
	var documentLabel = isSoumission ? "soumission" : "facture";
	var documentLabelUc = isSoumission ? "Soumission" : "Facture";

	if(email !== ""){

    let message = `
        Vous vous apprêtez à envoyer la ${documentLabel} #${invoice_id} au client à l'adresse courriel &lt;<b>${email}</b>&gt; <br><br>
        <b>Voulez-vous continuer?</b>
    `;

		var popup = bootbox.dialog({
			title: `Envoyer une ${documentLabel}`,
			message: message,
			buttons: {
				send: {
					label: "Envoyer",
					className: "purple",
					callback: function(){
						$("[data-bb-handler=send]").attr("disabled", "disabled");
						sendInvoice(invoice_id, email, function(isSuccess, data) {
							window.processPopupServerResponse(popup, isSuccess);
							if(isSuccess){
								toastr.success(`${documentLabelUc} envoyée avec succès!`)
							} else {
								toastr.error(`Échec de l'envoi de la ${documentLabel}.`)
								$("[data-bb-handler=send]").attr("disabled", null);
							}
						});
						return false;
					}
				},
				cancel: {
					label: "Annuler",
					className: "secondary",
					callback: function(){ }
				}
			}
		})
	} else {
		bootbox.alert(`Le client de cette ${documentLabel} n'a pas d'adresse courriel.`);
	}
}

/**
 * Effectue l'envoie de facture par courriel.
 * @param { number } invoice_id ID de la facture
 * @param { string } email Courriel destinataire.
 * @param { requestCallback } callback Réponse
 */
let sendInvoice = window.sendInvoice = function(invoice_id, email, callback) {
	if(callback === undefined) callback = function(isSuccess, data){ };
	
	var message_text = "<h1>"+L("SAVING")+"...<br>"+L("PLEASE_WAIT")+"</h1>";
	App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });

	$.post(window.baseUrl+"invoice/send/"+invoice_id+"?includeInspections=1", { email : email }, function(data) {
		var res = data.result;
		App.unblockUI();
		if(res === "success"){
			callback(true, data);
		}
		else{
			callback(false, data);
		}
	}, "json");
}